import { OAuthModuleConfig } from "angular-oauth2-oidc";

export function authConfigFactory(): OAuthModuleConfig {
    return {
      resourceServer: {
        allowedUrls: [],
        sendAccessToken: true,
      }
    };
  }